import React, { useState } from 'react';

const VideoMessage = ({ src }) => {
   const [failed, setFailed] = useState(false);
   if (!src) return null;
   if (failed) return <div className='chatterbox-media-error'>Media could not be loaded.</div>;

   return (
      <div className='chatterbox-media'>
         <video controls src={src} onError={() => setFailed(true)} />
      </div>
   );
};

export default VideoMessage;
